<template>

  <select v-model="currentValue" @change="emit()">
    <option :value="null">-</option>
    <option v-for="city in currentCities" :value="city.code" :key="city.code">{{ city.name }}</option>
  </select>

</template>

<script>
  import cities from '@/config/cities'

  export default {
    computed: {
      cities () {
        return cities.map(([code, name, state]) => ({ name, code, state }))
      },
      currentCities() {
        return this.cities.filter(c => c.state === this.codeUf)
      }
    },
    created() {
      this.currentValue = this.value
    },
    data: () => ({
      currentValue: null
    }),
    name: 'CitySelect',
    methods: {
      emit() {
        this.$emit('input', this.currentValue)
      }
    },
    props: {
      codeUf: { required: true },
      value: { type: String },
      nullValue: { type: Boolean, default: true }
    },
    watch: {
      codeUf() {
        this.currentValue = null
        this.emit()
      },
      value(newValue) {
        if (newValue !== this.currentValue)
          this.currentValue = newValue
      }
    }
  }
</script>

<style scoped>

</style>
